module.exports = __webpack_public_path__ + "by.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/by.svg
// module id = 729
// module chunks = 0